import React from 'react';
import { SVGProps } from './types';

const RupeeIcon: React.FC = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="7"
      height="12"
      fill="none"
      viewBox="0 0 7 12"
      {...props}
    >
      <path
        fill="#475467"
        d="M3.288 12L.264 6.72v-.704h.352c.565 0 1.04-.053 1.424-.16.395-.107.704-.283.928-.528.224-.245.357-.581.4-1.008H.264V3.296h3.088c-.075-.395-.224-.715-.448-.96-.224-.256-.528-.443-.912-.56C1.619 1.659 1.16 1.6.616 1.6H.264V.576h6.624V1.6H3.864c.245.203.448.443.608.72a2.5 2.5 0 01.304.976h2.112V4.32h-2.08c-.075.779-.373 1.387-.896 1.824-.512.427-1.195.699-2.048.816L4.92 12H3.288z"
      ></path>
    </svg>
  );
};

export { RupeeIcon };
